import { FC, useState, useRef, useEffect } from "react";
import {
  convertChannelName,
  convertChannelNameFee,
  convertPaymentSystem,
} from "../../lib/utils";

interface IGroupedCategoryList {
  label: string;
  code: Number;
}
interface ICurrencyFilter {
  value: string;
  options: Array<string>;
  onChange: (value: string, type?: string) => void;
  type: string;
  btnClass?: string;
  isDisable?: boolean;
  wrapperClass?: string;
  height?: number;
}

const CurrencyDrop: FC<ICurrencyFilter> = (props) => {
  const { value, options, onChange, type, btnClass, wrapperClass, height } = props;
  const [open, setOpen] = useState(false);
  const node = useRef<HTMLDivElement | null>(null);

  const handleClick = (event: MouseEvent): boolean | undefined => {
    if (node?.current?.contains(event.target as Node)) {
      return false;
    }

    setOpen(false);
    return true;
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClick);

    return () => {
      document.removeEventListener("mousedown", handleClick);
    };
  }, []);

  const handleChange = (selectedValue: string): void => {
    onChange(selectedValue, type);
    setOpen(false);
  };

  const handleSelectToggel = (): void => {
    setOpen(!open);
  };
  return (
    <div className={`select select--type2 ${wrapperClass && wrapperClass} ${open ? "active" : ""}`} ref={node} style={{height: height}}>
      <button
        type="button"
        className={`${btnClass} select__current `}
        onClick={handleSelectToggel}
        disabled={props.isDisable ?? false}
      >
        <span className="select__current-text font-semibold">
          {type === "chanel"
            ? convertChannelNameFee(value)
            : value?.toUpperCase()}
        </span>
        {props.isDisable === true ? null : (
          <span className="select__current-arrow">
            <svg
              className="stroke"
              width="8"
              height="5"
              viewBox="0 0 8 5"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M1 1L4 4L7 1" stroke="#424242" strokeLinecap="square" />
            </svg>
          </span>
        )}
      </button>
      {open && options && (
        <div className="select__drop max-h-[200px] overflow-auto thick-scrollbar">
          <div className="select__drop-scroll">
            <div className="select-drop__item">
              <ul>
                {options?.map((item) => (
                  <li key={item}>
                    <button type="button" onClick={() => handleChange(item)}>
                      {type === "chanel"
                        ? convertChannelNameFee(item)
                        : item?.toUpperCase()}
                    </button>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

CurrencyDrop.displayName = "CurrencyDrop";
export default CurrencyDrop;
